// src/js/Base/LocalStorageUtils.js
export const getStorageValue = (key) => {
  return localStorage.getItem(key);
};

export const getUserToken = () => {
  return getStorageValue('token');
};
